import faunadb from 'faunadb';
const client = new faunadb.Client({ secret: 'fnAFgFF2kDAAQP_qMsvytPjktH-MUxixi_Th0rxJ' });
export default client;
